module.exports = __webpack_public_path__ + "static/media/unsplash1.79935692.jpg";